import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c(VCheckbox, {
        staticClass: "mt-0 pt-0",
        attrs: { color: "primary", "hide-details": "" },
        model: {
          value: _setup.isAgree,
          callback: function ($$v) {
            _setup.isAgree = $$v
          },
          expression: "isAgree",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-2 text--text" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.t(
                "Регистрируясь на сайте, вы даете согласие на",
                _setup.options
              )
            ) +
            "\n    "
        ),
        _c(
          "a",
          {
            staticClass: "text-decoration-none primary--text d-inline",
            attrs: { href: "/info/privacy-policy/", target: "_blank" },
          },
          [
            _vm._v(
              _vm._s(_setup.t("обработку персональных данных", _setup.options))
            ),
          ]
        ),
        _vm._v(
          "\n    " + _vm._s(_setup.t("и принимаете", _setup.options)) + "\n    "
        ),
        _c(
          "a",
          {
            staticClass: "text-decoration-none primary--text d-inline",
            attrs: { href: "/info/terms-of-use/", target: "_blank" },
          },
          [
            _vm._v(
              _vm._s(_setup.t("пользовательское соглашение", _setup.options))
            ),
          ]
        ),
        _vm._v(".\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }